(() => {
  const initialise = (bar) => {
    if (!bar || bar.dataset.ecTrustReady === 'true') return;

    const messages = Array.from(bar.querySelectorAll('[data-ec-trust-message]'));
    const dots = Array.from(bar.querySelectorAll('[data-ec-trust-dot]'));
    if (!messages.length) return;

    bar.dataset.ecTrustReady = 'true';
    let activeIndex = 0;
    let timer = null;
    const interval = Math.max(3000, Number(bar.dataset.interval) || 5000);

    const show = (index) => {
      activeIndex = index % messages.length;
      messages.forEach((message, messageIndex) => {
        message.classList.toggle('is-active', messageIndex === activeIndex);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
      });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (messages.length < 2) return;
      timer = window.setInterval(() => show(activeIndex + 1), interval);
    };

    show(0);
    start();
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('[data-ec-sticky-trust-bar]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
